if (!customElements.get('magyou-personalize-bar')) {
  customElements.define('magyou-personalize-bar', class extends HTMLElement {
    connectedCallback() {
      const productInfo = document.querySelector('product-info');
      if (!productInfo) return;
      this.link = this.querySelector('a');
      if (!this.link) return;
      this.onClick = event => {
        const target = productInfo.querySelector('product-form');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center'});
        target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
      };
      this.link.addEventListener('click', this.onClick);
      this.observer = new IntersectionObserver(entries => {
        this.hidden = entries.some(entry => entry.isIntersecting);
      }, {threshold: 0.1});
      const observeTarget = () => {
        const target = productInfo.querySelector('product-form');
        if (!target || target === this.target) return;
        this.observer.disconnect();
        this.target = target;
        this.observer.observe(target);
      };
      observeTarget();
      this.formObserver = new MutationObserver(records => {
        if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
          node.nodeType === 1 && (node.matches('product-form') || node.querySelector('product-form'))
        ))) observeTarget();
      });
      this.formObserver.observe(productInfo, {childList: true, subtree: true});
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.formObserver?.disconnect();
      this.link?.removeEventListener('click', this.onClick);
    }
  });
}
document.addEventListener('click', event => {
  if (event.target.closest('.my-mobile-menu a')) document.querySelector('.my-mobile-menu')?.removeAttribute('open');
});

document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.my-mobile-menu[open]');
  if (!menu) return;
  menu.removeAttribute('open');
  menu.querySelector('summary')?.focus();
});

function magyouUploadContext(target) {
  if (!(target instanceof Element)) return null;
  const wrapper = target.closest('.cl-upload--wrapper');
  const product = wrapper?.closest('product-info[data-magyou-upload-error]');
  return product ? {wrapper, product} : null;
}

function magyouValidatePhotoSelection(event) {
  const context = magyouUploadContext(event.target);
  if (!context) return;
  const input = context.wrapper.querySelector('input[type="file"]');
  if (event.type === 'change' && event.target !== input) return;
  const files = event.type === 'drop' ? event.dataTransfer?.files : input?.files;
  if (!files?.length) return;
  let status = context.product.querySelector('[data-magyou-upload-status]');
  const invalid = [...files].some(file => !file.type.startsWith('image/') &&
    !((!file.type || file.type === 'application/octet-stream') &&
      /\.(jpe?g|png|webp|gif|avif|heic|heif|bmp|tiff?)$/i.test(file.name)));
  if (!invalid) {
    if (status) status.hidden = true;
    return;
  }
  event.preventDefault();
  event.stopImmediatePropagation();
  if (input) input.value = '';
  if (!status) {
    status = document.createElement('p');
    status.dataset.magyouUploadStatus = '';
    status.className = 'my-upload-validation';
    status.setAttribute('role', 'alert');
    context.wrapper.insertAdjacentElement('afterend', status);
  }
  status.textContent = context.product.dataset.magyouUploadError;
  status.hidden = false;
}
document.addEventListener('change', magyouValidatePhotoSelection, true);
document.addEventListener('drop', magyouValidatePhotoSelection, true);
